export default __webpack_public_path__ + "static/media/successModal.2ee17890.svg";